import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetOperatorList = createModule({
  base: 'GET_OPERATOR_LIST', apiDetails: {...SERVICE_ENDPOINT.OPERATOR, method: 'get'},
});

const AddOperator = createModule({
  base: 'ADD_OPERATOR', apiDetails: {...SERVICE_ENDPOINT.OPERATOR, method: 'post'}, enableNotification: true, customNotificationSuccessMessage: 'Operator Added Successfully',
});

const UpdateOperator = createModule({
  base: 'UPDATE_OPERATOR', apiDetails: {...SERVICE_ENDPOINT.OPERATOR, method: 'put'}, enableNotification: true, customNotificationSuccessMessage: 'Operator Updated Successfully'
});

const DeleteOperator = createModule({
  base: 'DELETE_OPERATOR', apiDetails: {...SERVICE_ENDPOINT.OPERATOR, method: 'delete'}, enableNotification: true, customNotificationSuccessMessage: 'Operator Deleted Successfully'
});

export {
  GetOperatorList, AddOperator, UpdateOperator, DeleteOperator,
};
